import styled from 'styled-components'

export const StyledFacebookResponseContentScriptTable = styled.div`
  height: calc(100vh - 300px);

  overflow: auto;
`
